import { render, staticRenderFns } from "./zhaopian.vue?vue&type=template&id=2c22e500&scoped=true"
import script from "./zhaopian.vue?vue&type=script&lang=js"
export * from "./zhaopian.vue?vue&type=script&lang=js"
import style0 from "./zhaopian.vue?vue&type=style&index=0&id=2c22e500&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c22e500",
  null
  
)

export default component.exports